/**
 * EmailRulesPanel — CSR filter-rules workspace (replaces list + reading panes).
 */
import { h } from 'preact'
import { EmailRulesList } from './EmailRulesList.jsx'
import { EmailRuleEditor } from './EmailRuleEditor.jsx'

export function EmailRulesPanel({ store, i18n }) {
  const mailboxes = store.mailboxes.value
  const mailboxId = store.rulesMailboxId.value
  const editingId = store.rulesEditingId.value
  const editingRule = editingId === 'new'
    ? null
    : store.rules.value.find(r => r.id === editingId) || null

  const selectedMailbox = mailboxes.find(mb => mb.id === mailboxId)
  const mailboxSubtitle = selectedMailbox
    ? (selectedMailbox.email || selectedMailbox.from_email || selectedMailbox.name)
    : null

  const mailboxOptionLabel = (mb) => {
    const addr = mb.email || mb.from_email
    return addr ? `${mb.name} — ${addr}` : mb.name
  }

  return (
    <div class="email-rules-panel">
      <div class="email-rules-header">
        <div class="email-rules-header-main">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary flex-shrink-0"
            onClick={() => store.closeRules()}
          >
            <i class="bi bi-arrow-left" /> {i18n?.t('emails.email_rules.back') || 'Back'}
          </button>
          <div class="email-rules-header-titles">
            <h5>{i18n?.t('emails.email_rules.title')}</h5>
            {mailboxSubtitle && (
              <p class="email-rules-subtitle text-truncate">{mailboxSubtitle}</p>
            )}
          </div>
        </div>

        <select
          class="form-select form-select-sm email-rules-mailbox-select"
          value={mailboxId ?? ''}
          onChange={e => store.setRulesMailbox(e.target.value || null)}
          aria-label={i18n?.t('emails.email_rules.form.mailbox_label')}
        >
          <option value="">{i18n?.t('emails.email_rules.pick_mailbox')}</option>
          {mailboxes.map(mb => (
            <option key={mb.id} value={mb.id}>{mailboxOptionLabel(mb)}</option>
          ))}
        </select>

        {mailboxId && editingId == null && (
          <button
            type="button"
            class="btn btn-sm btn-primary flex-shrink-0"
            onClick={() => store.startNewRule()}
          >
            <i class="bi bi-plus-lg" /> {i18n?.t('emails.email_rules.new_title')}
          </button>
        )}
      </div>

      <div class="email-rules-body">
        {!mailboxId ? (
          <div class="email-rules-empty">
            <div class="email-rules-empty-icon"><i class="bi bi-mailbox" /></div>
            <div class="email-rules-empty-title">{i18n?.t('emails.email_rules.pick_mailbox')}</div>
            <div class="email-rules-empty-hint">
              {i18n?.t('emails.email_rules.pick_mailbox_hint')}
            </div>
          </div>
        ) : editingId != null ? (
          <EmailRuleEditor
            store={store}
            i18n={i18n}
            mailboxId={mailboxId}
            rule={editingRule}
          />
        ) : (
          <EmailRulesList store={store} i18n={i18n} />
        )}
      </div>
    </div>
  )
}
